import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const isFor = ['Mamás con niños de 2 a 3 años bajo presión de inscripción escolar.', 'Familias que quieren dejar de gastar $80-$100 al mes en pañales.', 'Padres que trabajan y solo tienen un fin de semana para lograr este cambio.', 'Quienes buscan un método directo, sin rodeos y probado en el mercado americano.'];
const notFor = ['Personas que no están dispuestas a dedicar 3 días de atención total al niño.', 'Quienes prefieren métodos pasivos que tardan meses en dar resultados.', 'Niños con condiciones médicas crónicas que requieran supervisión pediátrica específica.'];
export function WhoIsForSection() {
  return <section className="bg-cream py-14 px-4" data-id="element-164">
      <div className="max-w-6xl mx-auto" data-id="element-165">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8" data-id="element-166">
          {/* IS FOR */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-white p-6 md:p-8 rounded-3xl shadow-lg border-t-8 border-t-green-400" data-id="element-167">
            <h3 className="text-2xl md:text-3xl font-bold text-dark-teal mb-5 flex items-center" data-id="element-168">
              Esto ES para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-169">
              {isFor.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-170">
                  <CheckCircle2 className="text-green-500 shrink-0 mt-1 mr-4 w-6 h-6" data-id="element-171" />
                  <span className="text-lg text-gray-700" data-id="element-172">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-6 md:p-8 rounded-3xl shadow-lg border-t-8 border-t-red-400/60" data-id="element-173">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-5 flex items-center" data-id="element-174">
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-175">
              {notFor.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-176">
                  <XCircle className="text-red-400/80 shrink-0 mt-1 mr-4 w-6 h-6" data-id="element-177" />
                  <span className="text-lg text-gray-600" data-id="element-178">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}